import { request } from '@/util/http'

// export const getList = (current, size, params) => {
//   return request({
//     url: '/health/bsmeterdataitem/getList',
//     method: 'get',
//     params: {
//       ...params,
//       current,
//       size
//     }
//   })
// }

export const getList = (current, size, params) => {
  return request({
    url: '/health/mometerdata/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const submitForm = (row) => {
  return request({
    url: '/health/mometerdata/submitFormMo',
    method: 'post',
    data: row
  })
}

export const moZcReport = (row) => {
  return request({
    url: '/health/mometerdata/moZcReport',
    method: 'post',
    data: row
  })
}

